import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/DigitalTools/LogisticsExplorer/components/SectionVideo/SectionVideo.module.scss';

const cn = classNames.bind(styles);

const SectionVideo = (): ReactElement => {

  return (
    <section className={cn('video')}>
      <div className={cn('container')}>

        <div className={cn('video__heading-box')}>
          <h2 className={cn('video__heading')}>
            Seamless Booking Requests
          </h2>
          <p className={cn('video__heading-description')}>
            Customers can calculate costs, compare options, and book
            shipments instantly using the logistics calculator. If a certain
            rate isn’t currently listed, they can simply send a Quick Request.
          </p>
        </div>

        <div className={cn('video__player')}>
          <video
            className={cn('video__player-video')}
            poster=""
            controls
          >
            <source
              src="/video/pages/DigitalTools/LogisticsExplorer/video.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>

      </div>
    </section>
  );
};

export default SectionVideo;